import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config/api';
import RewardCard from '../components/RewardCard';
import './Rewards.css';

const Rewards = ({ user }) => {
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (user) {
      fetchRewards();
    }
  }, [user, filter]);

  const fetchRewards = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/rewards`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRewards(response.data);
    } catch (error) {
      setError('Failed to load rewards');
      console.error('Error fetching rewards:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRedeem = async (reward) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/rewards/${reward._id}/redeem`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      alert(`Successfully redeemed ${reward.name}! Your new balance is ${response.data.newBalance} Reward points.`);
      
      // Refresh user data and rewards
      fetchRewards();
      // You might want to refresh user data here too
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to redeem reward');
    }
  };

  const filteredRewards = rewards.filter(reward => {
    const matchesFilter = filter === 'all' || reward.type === filter;
    const matchesSearch = reward.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         reward.description.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="rewards-page">
      <div className="container">
        <div className="rewards-header">
          <h1>Rewards Catalog</h1>
          <p>Redeem your points for amazing rewards</p>
          {user?.role === 'respondent' && (
            <div className="points-balance">
              <span className="points-label">Your Balance:</span>
              <span className="points-value">{user.pointsBalance || 0} Reward points</span>
            </div>
          )}
        </div>

        <div className="rewards-filters">
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search rewards..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
          
          <div className="filter-tabs">
            <button
              className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All Rewards
            </button>
            <button
              className={`filter-tab ${filter === 'gift_card' ? 'active' : ''}`}
              onClick={() => setFilter('gift_card')}
            >
              Gift Cards
            </button>
            <button
              className={`filter-tab ${filter === 'cash' ? 'active' : ''}`}
              onClick={() => setFilter('cash')}
            >
              Cash
            </button>
            <button
              className={`filter-tab ${filter === 'coupon' ? 'active' : ''}`}
              onClick={() => setFilter('coupon')}
            >
              Coupons
            </button>
            <button
              className={`filter-tab ${filter === 'product' ? 'active' : ''}`}
              onClick={() => setFilter('product')}
            >
              Products
            </button>
          </div>
        </div>

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        <div className="rewards-content">
          {filteredRewards.length > 0 ? (
            <div className="rewards-grid">
              {filteredRewards.map(reward => (
                <RewardCard
                  key={reward._id}
                  reward={reward}
                  user={user}
                  onRedeem={handleRedeem}
                />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <div className="empty-state-icon">🎁</div>
              <h3 className="empty-state-title">No rewards found</h3>
              <p className="empty-state-description">
                {searchTerm || filter !== 'all' 
                  ? 'Try adjusting your search or filters'
                  : 'Check back later for new rewards'
                }
              </p>
            </div>
          )}
        </div>

        {user?.role === 'respondent' && user.pointsBalance === 0 && (
          <div className="earn-points-cta">
            <div className="cta-content">
              <h3>Start Earning Points!</h3>
              <p>Complete surveys to earn points and redeem amazing rewards.</p>
              <a href="/projects" className="btn btn-primary btn-lg">
                Browse Available Projects
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Rewards;
